import { Outlet, Route, Routes } from 'react-router-dom';
import { RoutePaths } from '@shared/utils';
import {
  Account,
  Accounts,
  AlertsPage,
  CardPage,
  CardsPage,
  DashboardPage,
  ErrorPage,
  Payments,
  ProfilePage,
  RecipientEditor,
  Reports,
  Statements,
  Transaction,
  IntegrationsPage,
  IntegrationPage,
  IntegrationsCallbackPage,
  MessageCenterPage,
  UserManagementPage,
  UserPage,
} from '@pages';
import { PaymentOtherBankPage } from '@pages/payments';
import { CardSettlementPage } from '@pages/payments/subPages/cardSettlementPage';
import { RecipientItem } from '@pages/payments/subPages/recipient/recipientItem';
import { BetweenAccountsPage } from '@pages/payments/subPages/betweenAccount';

export const Private = () => {
  return (
    <Routes>
      <Route path={RoutePaths.dashboard.path} element={<DashboardPage />} />
      <Route path={RoutePaths.cards.path} element={<CardsPage />} />
      <Route path={RoutePaths.card.path} element={<CardPage />} />
      <Route path={RoutePaths.users.path} element={<UserManagementPage />} />
      <Route path={RoutePaths.user.path} element={<UserPage />} />
      <Route path={RoutePaths.integrations.path} element={<IntegrationsPage />} />
      <Route path={RoutePaths.integration.path} element={<IntegrationPage />} />
      <Route path={RoutePaths.messages.path} element={<MessageCenterPage />} />
      <Route path={RoutePaths.error.path} element={<ErrorPage />} />
      <Route path={RoutePaths.profile.path} element={<ProfilePage />} />
      <Route path={RoutePaths.callback.path} element={<IntegrationsCallbackPage />} />
      <Route path={RoutePaths.alerts.path} element={<AlertsPage />} />
      <Route path='/' element={<Outlet />}>
        {/* <Route path="alerts" element={<AlertsPage />} /> */}

        <Route path={RoutePaths.accounts.path} element={<Accounts />} />
        <Route path={RoutePaths.account.path} element={<Account />} />
        <Route path={RoutePaths.accountTransaction.path} element={<Transaction />} />
        <Route path={RoutePaths.paymentsInsignia.path} element={<BetweenAccountsPage />} />
        <Route path={RoutePaths.paymentsOther.path} element={<PaymentOtherBankPage />} />
        <Route path={RoutePaths.paymentsCard.path} element={<CardSettlementPage />} />
        <Route path={RoutePaths.paymentsRecipient.path} element={<RecipientItem />} />
        <Route path={RoutePaths.payments.path} element={<Outlet />}>
          <Route index element={<Payments />} />
          <Route path={RoutePaths.paymentRecipients.path} element={<Outlet />}>
            <Route path={RoutePaths.paymentNewRecipients.path} element={<RecipientEditor />} />
            <Route path={RoutePaths.paymentRecipient.path} element={<RecipientEditor />} />
          </Route>
        </Route>
        <Route path={RoutePaths.reports.path} element={<Reports />} />
        <Route path={RoutePaths.statements.path} element={<Statements />} />
      </Route>
      <Route path='*' element={<ErrorPage />} />
    </Routes>
  );
};
